import { render, staticRenderFns } from "./group-list-table.vue?vue&type=template&id=fff8e418&scoped=true&lang=pug"
import script from "./group-list-table.vue?vue&type=script&lang=js"
export * from "./group-list-table.vue?vue&type=script&lang=js"
import style0 from "./group-list-table.vue?vue&type=style&index=0&id=fff8e418&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fff8e418",
  null
  
)

export default component.exports